"use client";
import { usePathname, useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import useFetchApi from "@/hooks/useFetchApi";
import { MainContext } from "@/contexts/MainContext";
const FooterComponent = ({ menuItems, aboutUs, services }) => {
  const pathname = usePathname();
  const router = useRouter();
  if (pathname.includes("login") || pathname.includes("register")) {
    return <></>;
  }

  return (
    <div className="bg-[#0C1B56] text-white ">
      <div className=" flex flex-col section relative">
        <div className="z-10 text-white grid md:grid-cols-4 grid-cols-1 gap-[72px] py-[60px]">
          <div className="">
            <img src={"/images/logo.png"} alt="logo" />
            <p className="mt-[28px] !text-base">
              Đối tác tin cậy trong lĩnh vực đầu tư, phát triển và quản lý bất
              động sản cao cấp.
            </p>
          </div>
          <div>
            <h2 className="text-lg font-semibold mb-5 uppercase">Liên kết</h2>
            <div className="flex flex-col">
              {menuItems.map((menuItem, i) => (
                <Link
                  href={menuItem.link || menuItem.slug}
                  key={`menuItem-${menuItem.link || menuItem.slug}-${i}`}
                  className="py-[5px] text-base text-[#ced1dd] font-semibold hover:text-white"
                >
                  {menuItem.label}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <h2 className="text-lg font-semibold mb-5 uppercase">Dịch vụ</h2>
            <div className="flex flex-col">
              {services.map((service, i) => (
                <Link
                  href={`/dich-vu#${service.slug}`}
                  key={`service-${service.slug}-${i}`}
                  className="py-[5px] text-base text-[#ced1dd] font-semibold hover:text-white"
                >
                  {service.name}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <h2 className="text-lg font-semibold mb-5 uppercase">
              Thông tin liên hệ
            </h2>
            <div className="flex flex-col">
              <div className="text-[#ced1dd] text-base font-normal gap-4 flex flex-col">
                <p>{aboutUs?.diaChi || ""}</p>
                <p>{aboutUs?.soDienThoai || ""}</p>
                <p>{aboutUs?.email || ""}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-[65px] section text-[17px] leading-[30px]">
        <p>Copyright © 2026 Van Xuan All rights reserved.</p>
      </div>
    </div>
  );
};

export default FooterComponent;
